import request from '@/utils/request'


/**
 * 运维总览数据
 * @param {object} params 参数
 * @param {string} params.type - 类型 1月 2季度 3年
 * @param {string} params.year - 年份
 * @param {string} params.index - 1-4季度、1-12月
 * @returns 
 */
export function queryStatisticalData(params) {
  return request({
    url: '/dashboard/v3/ops/overview/queryStatisticalData',
    method: 'get',
    params
  })
}


/**
 * 电站和设备型号统计
 * @returns 
 */
export function queryStationData() {
  return request({
    url: '/dashboard/v3/ops/overview/queryStationData',
    method: 'get',    
  })
}

/**
 * 电站数据列表
 * @param {object} params 
 * @param {string} params.name - 电站名称 
 * @param {string} params.stationId - 电站ID
 * @param {number} params.pageNum - 页码 (query param)
 * @param {number} params.pageSize - 每页数量 (query param)
 * @returns 
 */
export function queryStationList(params) {
  return request({
    url: '/dashboard/v3/ops/overview/queryStationList',
    method: 'get',
    params
  })
}
